import React, { useEffect, useState } from 'react';
import { AppProvider, useAppContext } from './contexts/AppContext';

import './css/App.css';

import Home from './views/Home';
import Video from './views/Video';
import Energy from './views/Energy';
import Residential from './views/Residential';
import Commercial from './views/Commercial';
import GetToKnow from './views/GetToKnow';
import Renew from './views/Renew';
import PowerHours from './views/PowerHours';
import PowerForward from './views/PowerForward';

function AppContent({ windowSize }) {
  const { currentView, params } = useAppContext();

  // Render component based on currentView
  const renderCurrentView = () => {
    switch (currentView) {
      case 'home':
        return <Home height={windowSize.height} width={windowSize.width} />;

      case 'video':
        const { video } = params;
        return <Video video={video} />;

      case 'energy':
        return <Energy />;
      
      case 'commercial':
        return <Commercial />;

      case 'residential':
        return <Residential />;

      case 'gettoknow':
        return <GetToKnow />;

      case 'renew':
        return <Renew />;

      case 'powerhours':
        return <PowerHours />;

      case 'powerforward':
        return <PowerForward />;

      default:
        // Fallback to home for unknown views
        return <Home height={windowSize.height} width={windowSize.width} />;
    }
  };

  return renderCurrentView();
}

function App() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  const [backgroundLoaded, setBackgroundLoaded] = useState(false);

  useEffect(() => {
    /**
     * Doc title
     */
    document.title = 'PSO Van Application';

    // Preload the background image first
    const backgroundImg = new Image();
    backgroundImg.onload = () => {
      setBackgroundLoaded(true); // Set background as loaded
    };

    /**
     * Window resizing
     */
    // Handler to call on window resize
    function handleResize() {
      const theHeight = 844;
      const theWidth = 1500;

      let windowH;
      let windowW;

      if ( window.innerWidth < 800 ) {
        windowW = 800;
        windowH = 471;
      } else {
        windowH = window.innerHeight;
        windowW = window.innerWidth;
      }

      let widthRatio = (theHeight * windowW) / theWidth;

      // Set window width/height to state
      setWindowSize({
        width: windowW,
        height: widthRatio,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [backgroundLoaded]); // Empty array ensures that effect is only run on mount

  return (
    <main className="w-full min-h-screen flex ct-docs-disable-sidebar-content overflow-hidden relative">
      <div id='main' className=' relative' style={{height : windowSize.height, width: windowSize.width}}>
        <div className='content-container' style={{height : windowSize.height, width: windowSize.width}}>
          <AppProvider>
            <AppContent windowSize={windowSize} />
          </AppProvider>
        </div>
      </div>
    </main>
  );
}

export default App;
